import { scriptService } from "./ScriptService";
class ScriptBusService {
    constructor() {
        this.subscriptions = new Map();
    }
    subscribeBusMessage(room, scriptIdx, topic, callback) {
        let topicData = this.subscriptions.get(topic);
        if (!topicData) {
            topicData = {
                scripts: new Map(),
                rooms: new Map()
            };
            this.subscriptions.set(topic, topicData);
        }
        const roomId = room.roomUID.toString();
        const scriptData = {
            roomId,
            callback
        };
        topicData.scripts.set(scriptIdx, scriptData);
        let roomData = topicData.rooms.get(roomId);
        if (!roomData) {
            roomData = new Map();
            topicData.rooms.set(roomId, roomData);
        }
        roomData.set(scriptIdx, scriptData);
    }
    unsubscribeBusMessage(scriptIdx, topic) {
        const topicData = this.subscriptions.get(topic);
        if (!topicData)
            return;
        const scriptData = topicData.scripts.get(scriptIdx);
        if (!scriptData)
            return;
        topicData.scripts.delete(scriptIdx);
        const roomData = topicData.rooms.get(scriptData.roomId);
        if (!roomData)
            return;
        roomData.delete(scriptIdx);
    }
    sendBusMessage(room, scriptIdx, topic, data) {
        if (!scriptService.context)
            return;
        const topicData = this.subscriptions.get(topic);
        if (!topicData)
            return;
        const roomId = room.roomUID.toString();
        const roomData = topicData.rooms.get(roomId);
        if (!roomData)
            return;
        const results = [];
        for (const [id, script] of roomData) {
            if (scriptIdx !== id)
                continue;
            const result = script.callback(data);
            if (result) {
                const scriptInstance = scriptService.context.scripts.get(id);
                if (!scriptInstance)
                    continue;
                results.push({
                    name: scriptInstance.scriptName,
                    result
                });
            }
        }
        if (results.length) {
            return results;
        }
    }
}
export const scriptBusService = new ScriptBusService();
